import React from 'react';
import Box from '@mui/material/Box';
import { PrimaryBtn } from './StepShell';
import { useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import useAnalytics from '../../analytics/useAnalytics';

interface StepWelcomeProps {
  onNext: () => void;
  onSkip: () => void;
}

export default function Welcome({ onNext, onSkip }: StepWelcomeProps) {
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );

  const { track } = useAnalytics();

  const getStarted = () => {
    track('Personalized Plan Started');
    onNext();
  };

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        px: isSmallScreen ? '24px' : 0,
        pt: isSmallScreen ? '54px' : '40px',
        pb: isSmallScreen ? '28px' : '36px',
      }}
    >
      {/* Hero content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          maxWidth: isSmallScreen ? '100%' : 540,
          margin: isSmallScreen ? '0 0 12px 0' : '0 auto 12px',
          marginBottom: '12px',
          textAlign: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          component="h1"
          sx={{
            fontWeight: 600,
            fontSize: isSmallScreen ? 38 : 56,
            lineHeight: 1.05,
            letterSpacing: '-0.02em',
            m: 0,
            mt: '20px',
            mb: '14px',
            textWrap: 'balance',
          }}
        >
          Build your personalized plan
        </Box>
        <Box
          component="p"
          sx={{
            fontSize: isSmallScreen ? 17 : 19,
            m: 0,
            lineHeight: 1.5,
            maxWidth: 460,
          }}
        >
          A few quick questions and we'll pre-pick your meals. About a minute.
        </Box>
      </Box>

      {/* CTAs */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <PrimaryBtn onClick={getStarted}>Get started</PrimaryBtn>
        <Box
          component="button"
          onClick={onSkip}
          sx={{
            fontFamily: 'inherit',
            fontWeight: 600,
            fontSize: 14,
            background: 'transparent',
            border: 0,
            cursor: 'pointer',
            py: '12px',
          }}
        >
          Skip the plan, just browse the menu
        </Box>
      </Box>
    </Box>
  );
}
